// extracted by mini-css-extract-plugin
export default {"heroBg":"styles_heroBg__y2kTU","hero":"styles_hero__8w3A0","ttl":"styles_ttl__tzvzm","txt":"styles_txt__W5KBn","btns":"styles_btns__CHVhA","img":"styles_img__9z4ok"};